import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { IGetVisit } from 'src/app/interfaces/IGetVisit';
import { EpisodeOfCareService } from 'src/app/services/episodeOfCare.service';
import { PatientService } from 'src/app/services/patient.service';
import { SwalToastService } from 'src/app/services/swal.service';
import { date_format } from 'src/date/date.configuration';

@Component({
  selector: 'app-select-visit',
  templateUrl: './select-visit.component.html',
  styleUrls: ['./select-visit.component.css'],
  standalone: false,
})
export class SelectVisitComponent {
  @ViewChild('visitModalRef', { static: true }) visitModalRef!: NzModalRef;

  @Input() isVisitVisible: boolean = false;
  @Input() selectedPatientFullName = '';
  @Input() selectedPatientID?: number;
  @Input() selectedEOC?: number;
  @Input() existingVisits: IGetVisit[] = [];

  @Output() visitCancel = new EventEmitter<void>();

  isVisitLoading = false;
  visitSubmitted = false;

  isNewSelected = true;

  draftVisit?: number;

  constructor(
    private readonly translate: TranslateService,
    private readonly swalToastService: SwalToastService,
    private readonly eocService: EpisodeOfCareService,
    private readonly patientService: PatientService,
    private readonly router: Router
  ) {}

  handleVisitCancel() {
    this.visitCancel.emit();
  }

  selectNewVisit() {
    this.isNewSelected = true;
  }

  selectDraftVisit() {
    this.isNewSelected = false;
  }

  handleVisitSubmit() {
    if (
      !this.isNewSelected &&
      this.draftVisit &&
      this.selectedEOC &&
      this.selectedPatientID
    ) {
      this.handleVisitCancel();

      this.selectedEOC &&
        this.eocService.currentEocId.set(this.selectedEOC.toString());

      this.draftVisit &&
        this.eocService.currentVisitId.set(this.draftVisit.toString());

      this.patientService.patientIDsignal.set(
        this.selectedPatientID.toString()
      );

      this.router.navigate([
        '/ehr/inPatientView',
        this.patientService.patientIDsignal(),
        this.eocService.currentEocId(),
        this.eocService.currentVisitId(),
      ]);
    } else if (
      this.isNewSelected &&
      this.selectedEOC &&
      this.selectedPatientID
    ) {
      this.eocService.createNewVisit(this.selectedEOC).subscribe({
        next: (res) => {
          this.handleVisitCancel();
          res?.data?.episodeOfCareId?.toString() &&
            this.eocService.currentEocId.set(
              res?.data?.episodeOfCareId?.toString()
            );

          res?.data?.visitId?.toString() &&
            this.eocService.currentVisitId.set(res?.data?.visitId?.toString());

          this.patientService.patientIDsignal.set(
            this.selectedPatientID?.toString()!
          );

          this.router.navigate([
            '/ehr/inPatientView',
            this.patientService.patientIDsignal(),
            this.eocService.currentEocId(),
            this.eocService.currentVisitId(),
          ]);

          this.swalToastService.toastSuccess('New Visit created successfully');
        },
        error: (err) => {
          this.swalToastService.toastError('Unable to create New Visit');
        },
      });
    }
  }

  ngOnDestroy(): void {
    this.visitModalRef.destroy();
    this.visitCancel.emit();
  }

  formatDate(date?: string) {
    return date ? moment(date).format(date_format) : '';
  }
}
